import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;

  .title {
    font-size: 24px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 16px;
  }

  .description {
    font-size: 15px;
    color: #666666;
    margin-bottom: 24px;
    max-width: 400px;
    line-height: 1.5;
  }

  .button {
    margin-top: 12px;
  }
`;
